export default __webpack_public_path__ + "static/media/basket-icon.8ed37114.svg";